import { render, staticRenderFns } from "./EditCongress.vue?vue&type=template&id=54ee8402&"
import script from "./EditCongress.vue?vue&type=script&lang=js&"
export * from "./EditCongress.vue?vue&type=script&lang=js&"
import style0 from "./EditCongress.vue?vue&type=style&index=0&id=54ee8402&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports